import { Text } from "@blueprintjs/core"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import CustomTag from "components/Atoms/CustomTag"
import StringInput from "components/Atoms/StringInput"
import InteractiveIcon from "components/Molecules/InteractiveIcon"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  DISPATCH_CHANGE_ORDER_ITEM,
  TOGGLE_ORDER_ITEM,
} from "store/dispatch.redux"
import { ErrorToast } from "utils/AppToaster"
import OrderItemDetail from "./OrderItemDetail"
const EditOrderItem = ({ item, orderId, itemIndex }) => {
  const [isOpen, setOpen] = useState(false)
  const quantity = item?.quantity ?? 0
  const booked = item?.bookedQuantity ?? 0
  const required = item?.requiredQuantity ?? 0
  const bookableQty = quantity - booked
  const dispatch = useDispatch()

  const isSelected = useSelector((state: any) => {
    const order = state.dispatch?.selectedOrders?.get(orderId)
    return order?.orderItems?.find(i => i.id === item?.id)?.isSelected
  })

  const disabled = booked === quantity
  return (
    <>
      <div className="p-3 ds-orders-list">
        <div>
          <CustomCheckbox
            disabled={disabled}
            checked={isSelected}
            onClick={e => {
              dispatch({
                type: TOGGLE_ORDER_ITEM,
                payload: {
                  orderId,
                  itemId: item?.id,
                },
              })
            }}
            className="mb-0"
          />
        </div>
        <StringInput
          disabled={disabled}
          onChange={(_, value) => {
            if (value > required + bookableQty) {
              return ErrorToast(
                `Picked quantity cannot be greater than the ordered quantity (${booked} booked already)`
              )
            }

            if (value < 0) {
              return ErrorToast(
                "Picked quantity should be greater than or equal to 0!"
              )
            }
            dispatch({
              type: DISPATCH_CHANGE_ORDER_ITEM,
              payload: {
                itemIndex,
                orderId,
                value,
              },
            })
          }}
          type="number"
          rightElement={
            <CustomTag minimal>
              {quantity} <span className="text-xs vt-muted">Units</span>
            </CustomTag>
          }
          className="vt-order-item-text-input mb-0"
          value={item?.newQuantity}
          big={false}
        />
        <div className="text-sm px-3">
          <div>
            <Text ellipsize={true}>{item?.sellableItem?.name}</Text>
          </div>
          <div>({booked} booked)</div>
        </div>
        <div>
          <InteractiveIcon
            onClick={() => setOpen(true)}
            className="ml-1"
            iconSize={16}
            icon="info-sign"
          />
        </div>
      </div>
      <OrderItemDetail
        itemId={item?.id}
        sellableItem={item?.sellableItem}
        isOpen={isOpen}
        onClose={e => setOpen(false)}
        quantity={quantity}
      />
    </>
  )
}

export default EditOrderItem
